import Head from 'next/head'
import { TeamGamesMetaDescription, TeamGamesOGImagePath } from 'utils/constants'

export default function HelpDetailsMetaTags() {
  return (
    <Head>
      <title>Find Help and Details for Team Games</title>
      <link rel="icon" href="/images/modal_logo.png" />
      <meta name="description" content={TeamGamesMetaDescription} />
      <meta name="og:image" content={TeamGamesOGImagePath} />
    </Head>
  )
}
